import React from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';

/**
 * A badge that explains itself on hover, and on focus: with a help text it
 * takes a tab stop, so the explanation is not reserved to a mouse. The id is
 * per row: with one id repeated down a table, every tooltip would hang on the
 * first row.
 */
const HelpBadge = ({ id, color, children, help }) => (
  <>
    <Badge
      id={id}
      color={color}
      className="font-size-12"
      tabIndex={help ? 0 : undefined}
      style={{ cursor: help ? 'help' : undefined }}
    >
      {children}
    </Badge>
    {help && (
      <UncontrolledTooltip placement="top" target={id}>
        {help}
      </UncontrolledTooltip>
    )}
  </>
);

export default HelpBadge;
